<template>
  <div class="success paymentResult" v-loading="loading">
    <div class="ps_box" v-if="!showDialog && showResult">
      <!-- 成功頁面 -->
      <div
        class="ps_success"
        v-if="
          $route.query.search ||
          payment.status == 'SUCCESS' ||
          payment.status == 'NOTIFIED'
        "
      >
        <img src="@/assets/Success.png" alt="" />
        <div class="result_text">
          <span v-if="serviceTypeConfig">
            <span
              v-if="serviceTypeConfig.serviceType === 'HZMB_MO_RENEW_PERSON'"
            >
              {{ $t("message.hzmbMoRenew.payment_success_personal", [spNo]) }}
            </span>
            <span v-if="serviceTypeConfig.serviceType === 'HZMB_MO_RENEW_COM'">
              {{ $t("message.hzmbMoRenew.payment_success_company", [spNo]) }}
            </span>
          </span>
        </div>
      </div>
      <!-- 錯誤頁面 -->
      <div class="ps_failed" v-else>
        <img src="@/assets/failed.png" alt="" />
        <div class="result_text">
          <span>{{ $t("message.canNotPay") }}</span>
        </div>
        <div class="ps_spNo">
          {{ $t("message.DataRegistration.Taxi.spNo") }}: {{ spNo }}
        </div>
        <div class="failed_reason">
          <div id="preview_message">
            {{ $t("message.DataRegistration.Taxi.failed_tips") }}
          </div>
        </div>
      </div>
      <GradientBtn style="margin-top: 24px" @click="back">{{
        $t("message.back")
      }}</GradientBtn>
    </div>

    <!-- 彈窗 -->
    <el-dialog
      :title="$t('message.pay_dialog_title')"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="400px"
      class="dialog_center_type trems_dialog"
      :before-close="handleClose"
    >
      <div class="way_tips_btn">
        <el-button type="primary" @click="detail">{{
          $t("message.pay_success")
        }}</el-button>
      </div>
      <div>
        {{ $t("message.closeDialog_in_seconds") }}{{ seconds
        }}{{ $t("message.closeDialog_in_seconds1") }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaymentAPI from "@/api/PaymentAPI";
import GradientBtn from "@/components/GradientBtn.vue";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
let timeout;
export default {
  components: { GradientBtn },
  data() {
    return {
      loading: false,
      payment: {},
      showDialog: false,
      seconds: 5,
      spNo: "",
      showResult: false,
      serviceTypeConfig: {},
    };
  },
  watch: {
    showDialog(newVal) {
      if (newVal) {
        setInterval(() => {
          this.seconds = this.seconds - 1;
        }, 1000);
      } else {
        setTimeout(() => {
          this.seconds = 5;
        }, 1000);
        this.detail();
      }
    },
  },
  methods: {
    back() {
      clearTimeout(timeout);
      this.$router.push("/");
    },
    // 查詢支付詳情
    async detail() {
      let transactionNo = this.$route.query.transactionNo;
      this.showDialog = false;
      this.loading = true;
      try {
        const info = await PaymentAPI.detail(transactionNo);
        this.loading = false;
        this.spNo = info.spNo || info.transactionNo;
        this.showResult = true;
        this.payment = info;
        if (!["NOTIFIED", "SUCCESS"].includes(info.status)) {
          timeout = setTimeout(() => {
            this.detail();
          }, 5000);
        }
      } catch (error) {
        this.$error(error);
      } finally {
        this.loading = false;
        this.showResult = true;
      }
    },
    handleClose() {
      this.showDialog = false;
    },
    // 獲取服務詳情
    getConfig() {
      const serviceType = localStorage.getItem("serviceType");
      ServiceTypeConfigAPI.getDetails(serviceType)
        .then((res) => {
          if (res) {
            res[`name${this.$t("message.lan")}`] = res[
              `name${this.$t("message.lan")}`
            ].replace("\\n", "");
          }
          this.serviceTypeConfig = res;
        })
        .catch((err) => {
          this.$error(err);
        });
    },
  },
  created() {
    const way = this.$route.query.way;
    if (way) {
      this.showDialog = false;
      this.detail();
    } else {
      this.showDialog = true;
      setTimeout(() => {
        this.showDialog = false;
      }, 5000);
    }
    // 澳門配額續期，獲取服務類型詳情
    this.getConfig();
  },
};
</script>

<style lang="scss" scoped>
.success {
  height: 500px;
}
.paymentResult {
  padding-left: 15px;
  padding-right: 15px;
}
.result_text {
  font-size: 30px;
  color: #333;
  margin-bottom: 24px;
  white-space: pre-wrap;
}

.ps_spNo {
  font-size: 26px;
}
.next_btn {
  padding-bottom: 0;
}
.way_tips_btn {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
}
/deep/.el-dialog {
  margin-top: 25vh !important;
}
</style>
